module.exports = __webpack_public_path__ + "static/profile_picture_destroyed_nose-30fa0e701202dae422955aecdee11f80.png";